export default {
  props: {
    /**
     * The default image source (or fallback)
     *
     * {
     *    src: '',
     *    width: '',
     *    height: '',
     *    srcset: ''
     * }
     */
    image: {
      type: Object,
      required: true,
    },
    imgClass: {
      type: String,
      default: '',
    },
    /**
     * Alternate text for the image
     */
    alt: {
      type: String,
      default: '',
    },
    /**
     * Enable or disable lazy-loading
     */
    lazy: {
      type: Boolean,
      default: false,
    },
    fade: {
      type: Boolean,
      default: false,
    },
    sources: {
      type: Array,
      default: () => [],
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
  },

  computed: {
    imgWidth() {
      return this.image.width ? this.image.width : this.width;
    },

    imgHeight() {
      return this.image.height ? this.image.height : this.height;
    },
  },
};
